import { MapMarker } from "./features/map/types";
import { Site, HealthStatus } from "./types";

function getCookie(name: string) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

function roundNumber(num: number, fractionDigits: number): number {
    return Number(num.toFixed(fractionDigits));
}

function siteToMarker(site: Site): MapMarker {
    return {
        id: site.id,
        active: site.active,
        latitude: site.latitude,
        longitude: site.longitude,
        title: `${site.name} (${site.health_status})`,
        health_status: site.health_status as HealthStatus,
        projectId: site.project.id,
        siteName: site.name,
        address: site.address,
        devices: site.devices,
        generation_kw: site.generation_kw,
        storage_capacity_kwh: site.storage_capacity_kwh,
        manufacturer: site.manufacturer
    }
}

const isUnderConstruction = (status?: string | null): boolean =>
    status === 'under-construction';

export { getCookie, roundNumber, siteToMarker, isUnderConstruction };
